import Vue from 'vue'
import App from './App.vue'

import VueAMap from "vue-amap";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'

Vue.config.productionTip = false



// 百度地图
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: '8MkVfkZg7sRCXrhioL9iFWaz9dwE6QWz'
})

Vue.use(ElementUI)

Vue.prototype.$axios = axios
Vue.use(VueAMap);

VueAMap.initAMapApiLoader({
	key: 'd3acb79f46858755ec9d791462a86836',
	plugin: [
		'AMap.Geocoder',
		'AMap.Autocomplete', // 输入提示插件
		'AMap.PlaceSearch', // POI搜索插件
		'AMap.Scale', // 右下角缩略图插件 比例尺
		'AMap.OverView', // 地图鹰眼插件
		'AMap.ToolBar', // 地图工具条
		'AMap.MapType', // 类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
		'AMap.PolyEditor', // 编辑 折线多，边形
		'AMap.CircleEditor', // 圆形编辑器插件
		'AMap.Geolocation' // 定位控件，用来获取和展示用户主机所在的经纬度位置
	],
	// 默认高德 sdk 版本为 1.4.4
	v: '1.4.4'
});

new Vue({
  render: h => h(App),
}).$mount('#app')
